export default __webpack_public_path__ + "static/needlefile-a26dc1a14be4fc0d9ed4d4d18cf8292b.png";